(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coffee-tabs"] && !Shopify.designMode) return;
  try {
    

  /*
   *   This content is licensed according to the W3C Software License at
   *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
   *
   *   File:   tabs-automatic.js
   *
   *   Desc:   Tablist widget that implements ARIA Authoring Practices
   */
  
  'use strict';
  
  class TabsAutomatic {
    constructor(groupNode) {
      this.tablistNode = groupNode;
  
      this.tabs = [];
  
      this.firstTab = null;
      this.lastTab = null;
  
      this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
      this.tabpanels = [];
  
      for (var i = 0; i < this.tabs.length; i += 1) {
        var tab = this.tabs[i];
        var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));
  
        tab.tabIndex = -1;
        tab.setAttribute('aria-selected', 'false');
        this.tabpanels.push(tabpanel);
  
        tab.addEventListener('keydown', this.onKeydown.bind(this));
        tab.addEventListener('click', this.onClick.bind(this));
  
        if (!this.firstTab) {
          this.firstTab = tab;
        }
        this.lastTab = tab;
      }
  
      this.setSelectedTab(this.firstTab, false);
    }
  
    setSelectedTab(currentTab, setFocus) {
      if (typeof setFocus !== 'boolean') {
        setFocus = true;
      }
      for (var i = 0; i < this.tabs.length; i += 1) {
        var tab = this.tabs[i];
        if (currentTab === tab) {
          tab.setAttribute('aria-selected', 'true');
          tab.removeAttribute('tabindex');
          this.tabpanels[i].classList.remove('is-hidden');
          if (setFocus) {
            tab.focus();
          }
        } else {
          tab.setAttribute('aria-selected', 'false');
          tab.tabIndex = -1;
          this.tabpanels[i].classList.add('is-hidden');
        }
      }
    }
  
    setSelectedToPreviousTab(currentTab) {
      var index;
  
      if (currentTab === this.firstTab) {
        this.setSelectedTab(this.lastTab);
      } else {
        index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(this.tabs[index - 1]);
      }
    }
  
    setSelectedToNextTab(currentTab) {
      var index;
  
      if (currentTab === this.lastTab) {
        this.setSelectedTab(this.firstTab);
      } else {
        index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(this.tabs[index + 1]);
      }
    }
  
    /* EVENT HANDLERS */
  
    onKeydown(event) {
      var tgt = event.currentTarget,
        flag = false;
  
      switch (event.key) {
        case 'ArrowLeft':
          this.setSelectedToPreviousTab(tgt);
          flag = true;
          break;
  
        case 'ArrowRight':
          this.setSelectedToNextTab(tgt);
          flag = true;
          break;
  
        case 'Home':
          this.setSelectedTab(this.firstTab);
          flag = true;
          break;
  
        case 'End':
          this.setSelectedTab(this.lastTab);
          flag = true;
          break;
  
        default:
          break;
      }
  
      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    }
  
    onClick(event) {
      this.setSelectedTab(event.currentTarget);
    }
  }
  
  // Initialize tablist
  
  window.addEventListener('load', function () {
    var tablists = document.querySelectorAll('[role=tablist].automatic');
    for (var i = 0; i < tablists.length; i++) {
      new TabsAutomatic(tablists[i]);
    }
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    

  // Pass URL query strings to "subject" form field
  
  function fillFormData() {
    const target = document.querySelector("[name='contact[subject]']");
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const subject = urlParams.get('subject');
    target.value = subject;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillFormData());
  }
  else {
    fillFormData();
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["livia-gp-highlight-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initCarousel(root) {
    if (root.__lgpInit) return;
    root.__lgpInit = true;

    var track = root.querySelector('[data-carousel-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
    var autoplayMs = parseInt(root.getAttribute('data-autoplay-ms'), 10) || 0;

    if (!track || slides.length === 0) return;

    var state = { index: 0, dragging: false, dragDX: 0, startX: 0, width: 0 };
    var timer = null;

    function render() {
      var base = -state.index * 100;
      var x = 'calc(' + base + '% + ' + state.dragDX + 'px)';
      track.style.transform = 'translateX(' + x + ')';
      track.classList.toggle('is-dragging', state.dragging);
      root.classList.toggle('is-dragging', state.dragging);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === state.index);
      });
    }

    function goTo(i) {
      var n = slides.length;
      state.index = (i % n + n) % n;
      render();
    }

    function startAuto() {
      stopAuto();
      if (!autoplayMs || slides.length < 2) return;
      timer = setInterval(function () {
        if (document.hidden || state.dragging) return;
        goTo(state.index + 1);
      }, autoplayMs);
    }

    function stopAuto() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        startAuto();
      });
    });

    root.addEventListener('pointerdown', function (e) {
      state.width = root.clientWidth;
      state.startX = e.clientX;
      state.dragging = true;
      state.dragDX = 0;
      render();

      function move(ev) {
        var dx = ev.clientX - state.startX;
        var atStart = state.index === 0;
        var atEnd = state.index === slides.length - 1;
        if ((atStart && dx > 0) || (atEnd && dx < 0)) dx *= 0.35;
        state.dragDX = dx;
        render();
      }

      function up(ev) {
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', up);
        var dx = ev.clientX - state.startX;
        var threshold = Math.max(60, state.width * 0.15);
        var target = state.index;
        if (dx <= -threshold) target = state.index + 1;
        else if (dx >= threshold) target = state.index - 1;
        state.dragging = false;
        state.dragDX = 0;
        goTo(target);
        startAuto();
      }

      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', up);
    });

    render();
    startAuto();
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) startAuto();
    });
  }

  function initVideo(video) {
    if (video.__lgpInit) return;
    video.__lgpInit = true;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    var kick = function () {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    };
    video.addEventListener('ended', function () {
      video.currentTime = 0;
      kick();
    });
    video.addEventListener('canplay', kick);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) kick();
    });
    kick();
  }

  function initAll(scope) {
    scope = scope || document;
    Array.prototype.slice.call(scope.querySelectorAll('[data-lgp-carousel]')).forEach(initCarousel);
    Array.prototype.slice.call(scope.querySelectorAll('[data-lgp-autoplay-video]')).forEach(initVideo);
  }

  window.addEventListener('load', function () {
    initAll(document);
  });
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-content"] && !Shopify.designMode) return;
  try {
    

  /*
   *   This content is licensed according to the W3C Software License at
   *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
   *
   *   File:   tabs-automatic.js
   *
   *   Desc:   Tablist widget that implements ARIA Authoring Practices
   */
  
  'use strict';
  
  class TabsAutomatic {
    constructor(groupNode) {
      this.tablistNode = groupNode;
  
      this.tabs = [];
  
      this.firstTab = null;
      this.lastTab = null;
  
      this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
      this.tabpanels = [];
  
      for (var i = 0; i < this.tabs.length; i += 1) {
        var tab = this.tabs[i];
        var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));
  
        tab.tabIndex = -1;
        tab.setAttribute('aria-selected', 'false');
        this.tabpanels.push(tabpanel);
  
        tab.addEventListener('keydown', this.onKeydown.bind(this));
        tab.addEventListener('click', this.onClick.bind(this));
  
        if (!this.firstTab) {
          this.firstTab = tab;
        }
        this.lastTab = tab;
      }
  
      this.setSelectedTab(this.firstTab, false);
    }
  
    setSelectedTab(currentTab, setFocus) {
      if (typeof setFocus !== 'boolean') {
        setFocus = true;
      }
      for (var i = 0; i < this.tabs.length; i += 1) {
        var tab = this.tabs[i];
        if (currentTab === tab) {
          tab.setAttribute('aria-selected', 'true');
          tab.removeAttribute('tabindex');
          this.tabpanels[i].classList.remove('is-hidden');
          if (setFocus) {
            tab.focus();
          }
        } else {
          tab.setAttribute('aria-selected', 'false');
          tab.tabIndex = -1;
          this.tabpanels[i].classList.add('is-hidden');
        }
      }
    }
  
    setSelectedToPreviousTab(currentTab) {
      var index;
  
      if (currentTab === this.firstTab) {
        this.setSelectedTab(this.lastTab);
      } else {
        index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(this.tabs[index - 1]);
      }
    }
  
    setSelectedToNextTab(currentTab) {
      var index;
  
      if (currentTab === this.lastTab) {
        this.setSelectedTab(this.firstTab);
      } else {
        index = this.tabs.indexOf(currentTab);
        this.setSelectedTab(this.tabs[index + 1]);
      }
    }
  
    /* EVENT HANDLERS */
  
    onKeydown(event) {
      var tgt = event.currentTarget,
        flag = false;
  
      switch (event.key) {
        case 'ArrowLeft':
          this.setSelectedToPreviousTab(tgt);
          flag = true;
          break;
  
        case 'ArrowRight':
          this.setSelectedToNextTab(tgt);
          flag = true;
          break;
  
        case 'Home':
          this.setSelectedTab(this.firstTab);
          flag = true;
          break;
  
        case 'End':
          this.setSelectedTab(this.lastTab);
          flag = true;
          break;
  
        default:
          break;
      }
  
      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    }
  
    onClick(event) {
      this.setSelectedTab(event.currentTarget);
    }
  }
  
  // Initialize tablist
  
  window.addEventListener('load', function () {
    var tablists = document.querySelectorAll('[role=tablist].automatic');
    for (var i = 0; i < tablists.length; i++) {
      new TabsAutomatic(tablists[i]);
    }
  });
  

  } catch(e) { console.error(e); }
})();
})();
